import tasks from './tasks';

export default {
  tasks,
};
